import React from "react";
import "./styles.scss";

export const Aside = ({ children }) => {
  return <div className="form-wrapper__aside">{children}</div>;
};

export const FormWrapper = ({ children }) => {
  return <div className="form-wrapper">{children}</div>;
};

export const LoadingWrapper = ({ children }) => {
  return <div className="loading-form-wrapper">{children}</div>;
};
